import React, { FC, useCallback } from 'react';

import ConditionRow from './ConditionRow';
import { CustomerAssigneeCondition as CustomerAssigneeConditionType } from 'src/actions/rules/condition';
import { StyledDropdown } from 'src/presentation/components/pages/rules/shared/StyledComponents';

enum Assigned {
  True = 'TRUE',
  False = 'FALSE',
}

type CustomerAssigneeConditionProps = {
  condition: CustomerAssigneeConditionType;
  index: number;
  onDelete: Function;
  onUpdate: Function;
};

const CustomerAssigneeCondition: FC<CustomerAssigneeConditionProps> = ({ condition, index, onDelete, onUpdate }) => {
  const onChannelChange = useCallback(
    val => {
      condition.setValue(val === Assigned.True);
      onUpdate({ condition, index });
    },
    [condition, index, onUpdate]
  );
  return (
    <ConditionRow index={index} onDelete={onDelete} text="Dedicated Hero is">
      <StyledDropdown
        onSelect={onChannelChange}
        options={assignmentOptions}
        value={condition.value ? Assigned.True : Assigned.False}
      />
    </ConditionRow>
  );
};

// dropdown selection does not render when using false as a boolean
const assignmentOptions: { label: string; value: string }[] = [
  { label: 'assigned', value: Assigned.True },
  { label: 'not assigned', value: Assigned.False },
];

export default CustomerAssigneeCondition;
